import HouseIcon from '@mui/icons-material/House';
import LocalLaundryServiceIcon from '@mui/icons-material/LocalLaundryService';
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
import DryCleaningIcon from '@mui/icons-material/DryCleaning';
import Inventory2Icon from '@mui/icons-material/Inventory2';
import BusinessIcon from '@mui/icons-material/Business';

import cardphoto1 from '../../assets/card1.webp';
import cardphoto2 from '../../assets/card2.webp';
import cardphoto3 from '../../assets/card3.webp';
import cardphoto4 from '../../assets/card4.webp';
import cardphoto5 from '../../assets/card5.webp';
import cardphoto6 from '../../assets/card6.webp';

export type ServiceId =
  | 'residential'
  | 'deep_clean'
  | 'window_clean'
  | 'extra'
  | 'move_out_clean'
  | 'office_clean';

export type ServiceDefinition = {
  id: ServiceId;
  icon: React.ReactElement;
  image?: string;
  nameKey: string;
  descKey: string;
  detailKey: string;
};

export const serviceDefinitions: Record<ServiceId, ServiceDefinition> = {
  residential: {
    id: 'residential',
    icon: (
      <HouseIcon
        sx={{ color: (theme) => theme.palette.primary.main, fontSize: 48 }}
      />
    ),
    image: cardphoto1,
    nameKey: 'services.residential',
    descKey: 'services.residential_desc',
    detailKey: 'services.residential_detail',
  },
  deep_clean: {
    id: 'deep_clean',
    icon: (
      <LocalLaundryServiceIcon
        sx={{ color: (theme) => theme.palette.primary.main, fontSize: 48 }}
      />
    ),
    image: cardphoto2,
    nameKey: 'services.deep_clean',
    descKey: 'services.deep_clean_desc',
    detailKey: 'services.deep_clean_detail',
  },
  window_clean: {
    id: 'window_clean',
    icon: (
      <AutoAwesomeIcon
        sx={{ color: (theme) => theme.palette.primary.main, fontSize: 48 }}
      />
    ),
    image: cardphoto3,
    nameKey: 'services.window_clean',
    descKey: 'services.window_clean_desc',
    detailKey: 'services.window_clean_detail',
  },
  extra: {
    id: 'extra',
    icon: (
      <DryCleaningIcon
        sx={{ color: (theme) => theme.palette.primary.main, fontSize: 48 }}
      />
    ),
    image: cardphoto4,
    nameKey: 'services.extra',
    descKey: 'services.extra_desc',
    detailKey: 'services.extra_detail',
  },
  move_out_clean: {
    id: 'move_out_clean',
    icon: (
      <Inventory2Icon
        sx={{ color: (theme) => theme.palette.primary.main, fontSize: 48 }}
      />
    ),
    image: cardphoto5,
    nameKey: 'services.move_out_clean',
    descKey: 'services.move_out_clean_desc',
    detailKey: 'services.move_out_clean_detail',
  },
  office_clean: {
    id: 'office_clean',
    icon: (
      <BusinessIcon
        sx={{ color: (theme) => theme.palette.primary.main, fontSize: 48 }}
      />
    ),
    image: cardphoto6,
    nameKey: 'services.office_clean',
    descKey: 'services.office_clean_desc',
    detailKey: 'services.office_clean_detail',
  },
};
